'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _containers = require('containers');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Home.scss');
var mouseImg = require('./mouse.png');

var fixedHeaderHeight = 70;

var Home = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    action: ownProps.params.action,
    isMobile: state.common.isMobile,
    isNewPassword: !!Number(ownProps.location.query.new),
    pathname: ownProps.location.pathname,
    queryCode: ownProps.location.query.code,
    queryEmail: ownProps.location.query.email,
    queryKey: ownProps.location.query.key
  };
}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(Home.prototype.__proto__ || (0, _getPrototypeOf2.default)(Home.prototype), 'componentDidMount', this).call(this, this.initVideo, 500);

      var pathname = this.props.pathname;

      if (pathname.startsWith('/password')) {
        this.openForgotPasswordForm();
      }
    }
  }, {
    key: 'initVideo',
    value: function initVideo() {
      var isMobile = this.props.isMobile;


      if (!isMobile) {
        if (!this.videoEl.paused) {
          return false;
        }
        window.addEventListener('touchstart', function videoStart() {
          this.videoEl.play();
          this.removeEventListener('touchstart', videoStart);
        });
      }
    }
  }, {
    key: 'openContactForm',
    value: function openContactForm() {
      this.loginContactEl.getWrappedInstance().open();
    }
  }, {
    key: 'openForgotPasswordForm',
    value: function openForgotPasswordForm() {
      this.forgotPasswordDialogEl.getWrappedInstance().getWrappedInstance().open();
    }
  }, {
    key: 'scrollBottom',
    value: function scrollBottom() {
      var copyrightElRect = this.copyrightEl.getBoundingClientRect();
      window.scroll({ top: copyrightElRect.bottom + scrollY - fixedHeaderHeight, left: 0, behavior: 'smooth' });
    }

    /* eslint-disable max-len */

  }, {
    key: 'renderFeatures',
    value: function renderFeatures() {
      var t = this.props.t;

      var features = [{
        title: t('Powerful collaboration and workflow platform'),
        text: t('Make managing your entire creative process more effective. Create teams and share projects globally within your organisation giving you total control of who has access to distribute and receive content.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./collaboration-graphics.png'),
        icon: require('./collaboration-icon.png')
      }, {
        title: t('Secure'),
        text: t('Using the highest security protocols combined with proprietary Watermark technology, your content is safe with us. In the event of a leak you will know who is responsible. Cybersecurity an arms race and we constantly review the body of technologies, processes and practices designed to protect our networks and data from attack, damage or unauthorized access.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./secure-graphics.png'),
        icon: require('./secure-icon.png')
      }, {
        title: t('Simple'),
        text: t('Using our intuitive interface you will be sending out music securely in no time at all. Reach your target audience within minutes. No more CD\'s, no Courier costs, no pain, no waste.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./simple-graphics.png'),
        icon: require('./simple-icon.png')
      }, {
        title: t('Quick Send'),
        text: t('In a rush...? Try out our new Quick Send feature. Send tracks in just seconds. Don\'t compromise your IP by using available cloud services such as Dropbox, Google or Box, Take advantage of our secure environment and all of our security features. Everything will be Watermarked for you automatically when you use this feature.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./qs-graphics.png'),
        icon: require('./qs-icon.png')
      }, {
        title: t('Mobile and apps'),
        text: t('Work from anywhere and also use our apps when you\'re on the go, available for iOS and Android. Listen offline, create Playlists and send feedback directly from the app.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./mobile-apps-graphics.png'),
        icon: require('./mobile-apps-icon.png')
      }, {
        title: t('Reporting'),
        text: t('Track the performance of your campaigns through metrics, such as user activity, location, duration and frequency of use; helping you better to engage, understand and effectively target your audience.'),
        feedback: {
          text: '',
          author: '',
          company: ''
        },
        graphics: require('./reporting-graphics.png'),
        icon: require('./reporting-icon.png')
      }];

      var getTextPart = function getTextPart(feature) {
        return _react2.default.createElement(
          'div',
          { className: styles.textBlock },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement('img', { src: feature.icon, className: styles.headIcon, alt: '' }),
            _react2.default.createElement(
              'span',
              { className: styles.title },
              feature.title
            )
          ),
          _react2.default.createElement('img', { src: feature.graphics, className: (0, _bind2.default)(styles.graphics, 'visible-xs-inline'), alt: '' }),
          _react2.default.createElement(
            'div',
            { className: styles.text },
            feature.text
          ),
          _react2.default.createElement(
            'div',
            { className: styles.feedback },
            feature.feedback.text && _react2.default.createElement(
              'div',
              { className: styles.feedbackText },
              '"',
              feature.feedback.text,
              '"'
            ),
            feature.feedback.author && _react2.default.createElement(
              'div',
              { className: styles.feedbackAuthor },
              feature.feedback.author,
              ', ',
              feature.feedback.company
            )
          )
        );
      };

      var getGraphicsPart = function getGraphicsPart(feature) {
        return _react2.default.createElement('img', { src: feature.graphics, className: (0, _bind2.default)(styles.graphics, 'hidden-xs'), alt: '' });
      };

      /* eslint-disable react/no-array-index-key */
      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.features) },
        _react2.default.createElement(
          'div',
          null,
          features.map(function (feature, index) {
            return _react2.default.createElement(
              'div',
              { key: index, className: styles.feature },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                index % 2 === 0 ? getTextPart(feature) : getGraphicsPart(feature)
              ),
              _react2.default.createElement(
                'div',
                { className: styles.right },
                index % 2 ? getTextPart(feature) : getGraphicsPart(feature)
              )
            );
          })
        )
      );
      /* eslint-enable react/no-array-index-key */
    }
    /* eslint-enable max-len */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          queryCode = _props.queryCode,
          queryKey = _props.queryKey,
          isNewPassword = _props.isNewPassword,
          action = _props.action,
          isMobile = _props.isMobile,
          queryEmail = _props.queryEmail;
      var isMounted = this.state.isMounted;


      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(styles.copyright, (0, _defineProperty3.default)({}, styles.withBg, isMobile && isMounted)), ref: function ref(el) {
              return _this2.copyrightEl = el;
            } },
          _react2.default.createElement('div', { className: styles.mask }),
          !isMobile && _react2.default.createElement(
            'video',
            { preload: 'auto', loop: true, autoPlay: true, ref: function ref(el) {
                return _this2.videoEl = el;
              } },
            _react2.default.createElement('source', { src: 'https://s3-eu-west-1.amazonaws.com/crightvideo/crightLanding.mp4', type: 'video/mp4' }),
            _react2.default.createElement('source', { src: 'https://s3-eu-west-1.amazonaws.com/crightvideo/crightLanding.webm', type: 'video/webm' })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _bind2.default)('homeContent', styles.content) },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              t('protect your copyright!')
            ),
            _react2.default.createElement(
              'div',
              { className: styles.subTitle },
              t('Secure digital content delivery')
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              t('Use CRight to distribute your content to whoever you want whenever you want.'),
              _react2.default.createElement('br', null),
              t('You are in control - your content is only available to the people you authorize.')
            ),
            _react2.default.createElement(
              'div',
              { className: styles.buttonContainer },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-accent big', onClick: this.openContactForm },
                t('Contact Us')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.scrollHint },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { src: mouseImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('i', { className: (0, _bind2.default)('icon-chevron-thin-down', styles.scrollButton), onClick: this.scrollBottom })
            )
          )
        ),
        this.renderFeatures(),
        _react2.default.createElement(
          'div',
          { className: styles.moreLine },
          _react2.default.createElement(
            'span',
            { className: styles.moreHeader },
            t('And so much more')
          ),
          _react2.default.createElement(
            'button',
            { className: 'btn btn-accent', onClick: this.openContactForm },
            t('Contact us')
          )
        ),
        _react2.default.createElement(_containers.ForgotPasswordDialog, {
          ref: function ref(el) {
            return _this2.forgotPasswordDialogEl = el;
          },
          passwordKey: queryKey,
          passwordEmail: queryEmail,
          passwordCode: queryCode,
          isNew: isNewPassword,
          step: action
        }),
        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
            return _this2.loginContactEl = el;
          } })
      );
    }
  }]);
  return Home;
}(_ClientSideComponent2.default), _class3.propTypes = {
  action: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isNewPassword: _propTypes2.default.bool,
  pathname: _propTypes2.default.string,
  queryCode: _propTypes2.default.string,
  queryEmail: _propTypes2.default.string,
  queryKey: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'initVideo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'scrollBottom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'scrollBottom'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderFeatures', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderFeatures'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 2159
// module chunks = 1